import { StatusCodesConstants } from '../utilities/appConstants'
export interface StandardResponse {
    success: boolean;
    status: number; 
    data: any;
    headers: Record<string, string>; 
    url: string;
}
  
export const defaultStandardResponse: StandardResponse = {
    success: false,
    status: StatusCodesConstants.OK,
    data: {},
    headers: {},
    url: '',
};